<igo-spinner igoSpinnerActivity></igo-spinner>

<igo-auth-form *ngIf="authConfig && authConfig.url"></igo-auth-form>

<app-new-header *ngIf="hasHeader" #header></app-new-header>
<app-navigation-menu
  *ngIf="hasNavigationHeader"
  #navigationHeader
></app-navigation-menu>
<app-breadcrumb></app-breadcrumb>
<app-sub-menu></app-sub-menu>
<router-outlet></router-outlet>

<app-portal
  *ngIf="portal"
  [ngClass]="
    hasHeader
      ? hasFooter
        ? 'portal-with-header-footer'
        : 'portal-with-header'
      : hasFooter
        ? 'portal-with-footer'
        : 'portal'
  "
  igoStopDropPropagation
></app-portal>

<app-footer *ngIf="hasFooter" [isDisplayingMap]="portal"></app-footer>
